// src/store/modules/account.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    API_BIND_INFO,
    APP_BIND_FAILURE
} from '../../../config/mutation-types'

import {
    API_AI
} from '../../../config/const'


const state = {
    apiInfo: ''
}

const getters = {
    getBind: state => state.apiInfo
}

const actions = {
    getBind({commit}, options) {
        var uri = API_AI + "/h5/auth/thirdPartyBindingAndLogin"
        if(options.data.from && options.data.redirect){
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect
        }
        return new Promise((resolve, reject) => {
            Vue.http.post(uri, {
                mobilePhone: options.data.mobilePhone,
                validationCode: options.data.validationCode,
                channelId: options.data.channelId,
                openId: options.data.openId,
                unionId: options.data.unionId,
                nickname: options.data.nickname,
                headImgUrl: options.data.headImgUrl
            }).then((res, err) => {
                    resolve(res.data)
                }, (res) => {
                    reject(res.data)
                })
            }).then((res) => {
                commit(API_BIND_INFO, res)
            }, (err) => {
                commit(APP_BIND_FAILURE, err + '获取信息失败')
            })
    }
}

const mutations = {
    [API_BIND_INFO](state, data) {
        state.apiInfo = data
    },
    [APP_BIND_FAILURE](state, data) {
        state.apiInfo = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/login/bindUser.js